<template>
<div class="report-detail">
    <div v-if="!$store.state.report.isShowPersonalDetail" v-loading="detail.loading">
		<el-row class="rd-tool-bar">
			<el-button class="rd-btn" :loading="csvLoading" @click="getCSVData">
				下載報表
			</el-button>
			<downloadCsv ref="downloadCsv" :data = "csvData"
             name = "data.csv" :labels="labels" style="display: none;"></downloadCsv>
		</el-row>
        <el-row class="page-bar">
			<div>  </div>
			<el-pagination layout="prev, pager, next" prev-text="prev" next-text="next" 
                :current-page="$store.state.report.detailListStatus.pagination.current_page" 
                @current-change="detail_current_change" 
                :page-size="$store.state.report.detailListStatus.pagination.page_size" 
                :total="detailDataSoruce.length" style="float:right;">
			</el-pagination>
		</el-row>
        <el-table :data="detailData" v-loading="detail.loading" empty-text="暫無數據" style="width: 100%" class="detail-table">
			<el-table-column prop="name" label="姓名"> 
			</el-table-column>
			<el-table-column prop="actual_dep_name" label="部門">
			</el-table-column>
			<el-table-column prop="id" label="工號" >
			</el-table-column>
			<el-table-column prop="view_count" label="閱覽次數"  >
			</el-table-column>
			<el-table-column label="詳細記錄">
				<template slot-scope="scope">
					<el-button v-if="scope.row.view_count>0" type="text"  @click="listDetail(scope.row.id, scope.row.name)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
    </div>
    <div v-else>
        <el-row class="rd-tool-bar">
			<el-button class="rd-btn" :loading="csvLoadingDetail" @click="getCSVDataDetail">
				下載報表
			</el-button>
			<downloadCsv ref="downloadCsvDetail" :data = "csvDataDetail"
             name = "data.csv" :labels="labelsDetail" style="display: none;"></downloadCsv>
		</el-row>
        <el-row class="page-bar">
			<div>  </div>
			<el-pagination layout="prev, pager, next" prev-text="prev" next-text="next" 
                :current-page="$store.state.report.personalListStatus.pagination.current_page" 
                @current-change="personal_current_change" 
                :page-size="$store.state.report.personalListStatus.pagination.page_size" 
                :total="personalDataSoruce.length" style="float:right;">
			</el-pagination>
		</el-row>
        <el-table :data="personalData" v-loading="personal.loading" empty-text="暫無數據" style="width: 100%" class="detail-table">
			<el-table-column width="150px" prop="date" label="日期"> 
			</el-table-column>
			<el-table-column label="主題名稱">
                <template slot-scope="scope">
					<el-button type="text"  @click="goResource(scope.row.id)"> {{ scope.row.title }} </el-button>
				</template>
			</el-table-column>
			<el-table-column prop="file" label="檔案名稱" >
			</el-table-column>
			<el-table-column width="150px" prop="duration" label="觀看秒數"  >
			</el-table-column>
		</el-table>
    </div>
</div>
</template>

<script>
import API from '../../api/api';
export default {
    name: 'ReportDetail',
    data() {
        return {
            csvLoading: false,
            csvLoadingDetail: false,
            csvData:[],
            csvDataDetail:[],
            labels: {
                name: "姓名",
                actual_dep_name: "部門",
                id: "工號",
                view_count: "閱覽次數",
            },
            labelsDetail: {
                date: "日期",
                title: "主題",
                file: "名稱",
                duration: "觀看秒數",
            },
            detail: {
                loading: false,
            },
            personal: {
                loading: false,
            },
            detailData: [],
            detailDataSoruce: [],
            personalData: [],
            personalDataSoruce: [],
        }
    },
    watch: {
        '$store.state.report.dateRange': {
            immediate: false,
            handler(val) {
                if (this.$store.state.report.dateRange.length > 1) {
                    if (this.$store.state.report.dateRange[0] instanceof Date) {
                        this.$store.state.report.dateRange[0] = this.$store.state.report.dateRange[0].getTime();
                    }
                    if (this.$store.state.report.dateRange[1] instanceof Date) {
                        this.$store.state.report.dateRange[1] = this.$store.state.report.dateRange[1].getTime();
                    }
                    this.updateData();
                }
            }
        },
        '$store.state.report.selectedDepId': {
            immediate: false,
            handler(val) {
                this.updateData();
            }
        },
    },
    methods: {
        init() {
            console.log("ReportDetail init");
            this.updateData();
        },
        updateData() {
            this.reloadDetailData();
            this.reloadPersonalData();
        },
        reloadDetailData(id) {
            this.detail.loading = true;
            this.detailDataSoruce.splice(0);
            let actual_depid = null;
            let startTime = null;
            let endTime = null;
            if (this.$store.state.report.selectedDepId.length > 1) {
                actual_depid = this.$store.state.report.selectedDepId[1];
            }
            if (this.$store.state.report.dateRange.length > 1) {
                startTime = this.$store.state.report.dateRange[0];
                endTime = this.$store.state.report.dateRange[1];
            }
            API.getStatisticsViews({
                actual_depid: actual_depid,
                startTime: startTime,
                endTime:endTime,
			}).then((response) => {
                if(response.status) {
                    redirectLogin(response.data);
                } else {
                    for (let i = 0; i < response.result.length; i++) {
                        let item = {
                            id: response.result[i].user.username,
                            name: response.result[i].user.displayname,
                            actual_dep_id: response.result[i].actual_dep.id,
                            actual_dep_name: response.result[i].actual_dep.name,
                            view_count: response.result[i].view_count,
                        }
                        this.detailDataSoruce.push(item);
                    }

                    if (this.$store.state.entrance != "personalReport") {
                        this.$store.state.report.detailListStatus.pagination.current_page = 1;
                        this.$store.state.report.detailListStatus.pagination.offset = 0;
                        this.detailData = this.detailDataSoruce.slice(0, this.$store.state.report.detailListStatus.pagination.page_size);
                    } else {
                        this.detail_current_change(this.$store.state.report.detailListStatus.pagination.current_page);
                    }
                    
                }
                this.detail.loading = false;
            });
        },
        reloadPersonalData() {
            if (this.$store.state.report.personalListStatus.id == null) { return }
            this.personal.loading = true;
            this.personalDataSoruce.splice(0);
            let startTime = null;
            let endTime = null;
            if (this.$store.state.report.dateRange.length > 1) {
                startTime = this.$store.state.report.dateRange[0];
                endTime = this.$store.state.report.dateRange[1];
            }
            API.getStatisticsWatch({
                id: this.$store.state.report.personalListStatus.id,
                startTime: startTime,
                endTime:endTime,
			}).then((response) => {
                if(response.status) {
                    redirectLogin(response.data);
                } else {
                    for (let i = 0; i < response.result.length; i++) {
                        let d = new Date(response.result[i].date);
                        let dString = d.getFullYear() + '/' + (d.getMonth()+1) + '/' + d.getDate();
                        let item = {
                            date: dString,
                            id: response.result[i].resource_id,
                            title: response.result[i].resource_title,
                            file: response.result[i].file_name,
                            duration: response.result[i].file_watch_time,
                        }
                        this.personalDataSoruce.push(item);
                    }
                    if (this.$store.state.entrance != "personalReport") {
                        this.$store.state.report.personalListStatus.pagination.current_page = 1;
                        this.$store.state.report.personalListStatus.pagination.offset = 0;
                        this.personalData = this.personalDataSoruce.slice(0, this.$store.state.report.personalListStatus.pagination.page_size);
                    } else {
                        this.personal_current_change(this.$store.state.report.personalListStatus.pagination.current_page);
                    }
                }
                this.personal.loading = false;
            });
        },
        getCSVData() {
            this.csvLoading = true;
            this.csvData.splice(0);
            for (let i = 0; i < this.detailDataSoruce.length; i++) {
                let item = {};
                item.name = this.detailDataSoruce[i].name;
                item.actual_dep_name = this.detailDataSoruce[i].actual_dep_name;
                item.id = this.detailDataSoruce[i].id;
                item.view_count = this.detailDataSoruce[i].view_count;
                this.csvData.push(item);
            }

            this.$refs.downloadCsv.generate();
			this.csvLoading = false;
        },
        getCSVDataDetail() {
            this.csvLoadingDetail = true;
            this.csvDataDetail.splice(0);
            for (let i = 0; i < this.personalDataSoruce.length; i++) {
                let item = {};
                item.date = this.personalDataSoruce[i].date;
                item.title = this.personalDataSoruce[i].title;
                item.file = this.personalDataSoruce[i].file;
                item.duration = this.personalDataSoruce[i].duration;
                this.csvDataDetail.push(item);
            }

            this.$refs.downloadCsvDetail.generate();
			this.csvLoadingDetail = false;
        },
        detail_current_change(val) {
            let page_size = this.$store.state.report.detailListStatus.pagination.page_size;
            this.$store.state.report.detailListStatus.pagination.current_page = val;
            this.$store.state.report.detailListStatus.pagination.offset = page_size * (val - 1);
            let start = this.$store.state.report.detailListStatus.pagination.offset;
            this.detailData = this.detailDataSoruce.slice(start, start + page_size);
        },
        personal_current_change(val) {
            let page_size = this.$store.state.report.personalListStatus.pagination.page_size;
            this.$store.state.report.personalListStatus.pagination.current_page = val;
            this.$store.state.report.personalListStatus.pagination.offset = page_size * (val - 1);
            let start = this.$store.state.report.personalListStatus.pagination.offset;
            this.personalData = this.personalDataSoruce.slice(start, start + page_size);
        },
        listDetail(id, name) {
            this.$store.state.report.isShowPersonalDetail = true;
            this.$store.state.report.personalListStatus.id = id;
            this.$store.state.report.personalListStatus.name = name;
            this.reloadPersonalData();
        },
        goResource(id) {
            this.$store.state.barBreadcrumbs = [];
            this.$store.state.entrance = "personalReport";
            this.$router.push({ path: '/info/' +  id});
        }
    },
    created() {
        this.init();
    }
}
</script>

<style lang="scss">
.report-detail {

    .rd-tool-bar {
        background: #FFFFFF;
        height: 48px;

        .rd-btn {
            display: inline;
            float: right;
			background: #2E90F4;
			border-radius: 2px;
			color: #fff;
			font-size: 14px;
			height: 36px;
			border: none;
            margin-top: 6px;
            margin-right: 12px;
        }
    }

    .detail-table {
        cursor: auto;
    }
}
</style>


// WEBPACK FOOTER //
// ReportDetail.vue?764c4810